import { useTranslation } from "react-i18next"
import { Link, useParams } from "react-router-dom"
import HelmetLayout from "../../components/HelmetLayout/HelmetLayout";


export default function ThankYou() {
    const {t} = useTranslation()
    const a = t("thank_you.name")
    const b = t("header.title2")
    const c = a + " | "+ b
  
    return(
      <div className="reservation__content">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
          <h1>{t('thank_you.thank_content')}</h1>
          </div>
        </div>
      </div>
      <div className="container">
          <div className="row">
              <div className="col-md-12 pre-line">
              <h2 style={{color:'#fff'}}>{t("thank_you.title")}</h2>
              <br />
              <h4 style={{color:'#fff'}}>{t("thank_you.content")}</h4>
              </div>
          </div>
      </div>
    </div>
    )
}